import React, { useRef } from 'react'
import { cls } from 'utilities/dom'
import { useCommandBar } from 'contexts/command-bar'
import { getCategoryIcon } from 'utilities/categories'
import {
    ListItem,
    Button, Link, Anchor
} from '../../result/s'
import Shortcut from 'components/tiptap/help/shortcut'

const Action = ({ action, index }) => {
    const actionRef = useRef()

    const {
        execute,
        activeActionsIndex
    } = useCommandBar()

    const isActive = activeActionsIndex === index

    const {
        category,
        element = 'button',
        icon,
        link,
        shortcut = []
    } = action ?? {}

    const Icon = icon ?? getCategoryIcon(category)

    const Element = {
        a: Anchor,
        link: Link,
        button: Button
    }[element]

    const elementProps = {
        className: cls([
            'neutral',
            isActive && 'active',
            Icon && 'has-icon'
        ]),
        ...(link ? { link } : null)
    }

    return (
        <ListItem ref={actionRef}>
            <Element
                {...elementProps}
                onClick={() => execute(action)}>
                {Icon && <Icon size={16} />}
                <span>{action.label}</span>
                {!!shortcut.length && (
                    <Shortcut
                        shortcut={shortcut}
                        className="fill"
                        salt={`action:${action.actionId}:shortcut`} />
                )}
            </Element>
        </ListItem>
    )
}

export default Action